import { graphql } from 'src/graphql';

import { ParticipantSessionsHistoryFields } from './participantSessionsHistoryFields.fragment';

export const ParticipantSessionsPageCalendar = graphql(
  `
    fragment ParticipantSessionsPageCalendar on SessionsType @_unmask {
      _id
      _session_id
      _user_id
      status
      cancel
      cancel_reason
      user {
        _id
        email
        meta {
          identity {
            firstname
            lastname
            gender
            birthday {
              year
              timestamp
            }
            languages {
              english {
                speak {
                  native
                  fluent
                  conversational
                  beginner
                }
              }
            }
          }
          family {
            status {
              single
              relationship
              married
              divorced
              widowed
            }
          }
          education {
            highschool
            some_university
            undergraduate
            postgraduate
            apprenticeship
          }
          work {
            status {
              fulltime
              parttime
              fulltime_student
              unemployed
              homeduties
              retired
            }
          }
        }
        contact {
          phone {
            country_code
            mobile
          }
        }
      }
      completed
      rating {
        engagement
        punctuality
        overall
      }
      feedback {
        participant
      }
      Submission {
        _id
        role
        data {
          _question_id
          _answer_id
          value
        }
        agreement {
          status
        }
      }
      history {
        ...ParticipantSessionsHistoryFields
      }
    }
  `,
  [ParticipantSessionsHistoryFields],
);
